// extracted by mini-css-extract-plugin
module.exports = {"navigationItem":"NavigationItem_navigationItem__2hsul","active":"NavigationItem_active__2cloz"};